import React from "react";
import { DateTime } from "luxon";
import type { BillingAccountDetailDto } from "client/api-v2";
import type { EntityHistoryReferenceDto } from "client/api/EntityHistoryReferenceDto";
import { DetailsPageLayout } from "components/DetailsPageLayout/DetailsPageLayout";
import { EntityHistoryView } from "components/EntityHistoryView/EntityHistoryView";
import { useEntity } from "components/EntityProvider/EntityProvider";
import { PaperLayout } from "components/PaperLayout/PaperLayout";
import { getBillingAccountHistory, getBillingAccountHistorySnapshot } from "../services/billingAccountService";

export function BillingAccountHistory() {
  const { entity: billingAccount } = useEntity<BillingAccountDetailDto>();

  if (!billingAccount) return <></>;

  const getHistory = async (): Promise<EntityHistoryReferenceDto[]> => {
    const historyData = await getBillingAccountHistory(billingAccount.code);

    return historyData.map((item) => ({
      entityId: item.entityId,
      entityType: item.entityType,
      validFrom: DateTime.fromISO(item.validFrom),
      validTo: DateTime.fromISO(item.validTo),
      lastModifiedByUser: item.lastModifiedByUser,
    }));
  };

  const getHistoricalSnapshot = (asOf: DateTime): Promise<Record<string, unknown>> =>
    getBillingAccountHistorySnapshot(billingAccount.code, asOf.toISO());

  return (
    <PaperLayout maxWidth={false}>
      <DetailsPageLayout pageName={"History"}>
        <EntityHistoryView getEntityHistory={getHistory} getHistoricalEntity={getHistoricalSnapshot} />
      </DetailsPageLayout>
    </PaperLayout>
  );
}
